import {view, media, tokens} from '@sail/ui';
import {getStore} from 'src/v2/state/store';
import {MerchantLogo, Text, Link} from 'src/v2/components/common';
import {TestmodeBadge} from 'src/components/core/TestmodeBadge';
import {useContactSupportUrl} from 'src/v2/util/useContactSupportUrl';

import {message, useIntl} from '@sail/intl';

const messages = {
  needHelp: message({
    id: 'crypto.payins.v2.header.need_help',
    description: 'Link to the Stripe support page',
    defaultMessage: 'Need help?',
  }),
};

export const Header = () => {
  const intl = useIntl();
  const store = getStore();

  const logoUrl = store.useSelector((state) => state.merchantBranding.logoUrl);
  const livemode = store.useSelector((state) => state.livemode);
  const contactSupportUrl = useContactSupportUrl();

  return (
    <view.div
      css={{
        stack: 'x',
        height: 'space.900',
        distribute: 'space-between',
        alignY: 'center',
        paddingX: 'space.500',
        paddingY: 'space.0',
        [media.down(tokens.viewport.medium)]: {
          height: '48px',
          paddingX: '16px',
        },
      }}
      data-testid="v2-header"
    >
      <view.div
        css={{
          stack: 'x',
          gap: 'small',
          alignY: 'center',
          width: 'fit',
        }}
      >
        <MerchantLogo
          logoUrl={logoUrl}
          businessName={null}
          style={{maxHeight: '32px', width: 'auto'}}
        />
        {!livemode ? <TestmodeBadge /> : null}
      </view.div>

      <Link type="secondary" href={contactSupportUrl} target="_blank">
        <Text type="body" css={{color: 'subdued'}}>
          {intl.formatMessage(messages.needHelp)}
        </Text>
      </Link>
    </view.div>
  );
};
